import React from 'react';
import axios, { loginDestination } from '../../../api/appPublicApi';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { setUserInformation } from '../../../Redux/UserInformationSlice';
import {
  CssBaseline,
  Grid,
  TextField,
  Typography,
  Button,
  useTheme,
  CircularProgress,
} from '@mui/material';
import { Alert } from '@mui/material';
import { Box } from '@mui/system';
import jwt_decode from 'jwt-decode';
import { setUserPermission } from '../../../Redux/UserPermissionSlice';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  '& label.MuiInputLabel-root': {
    color: 'rgba(0, 0, 0, 0.54)',
    backgroundColor: 'white',
    padding: '0 4px',
    marginLeft: '-4px',
  },
  '& .MuiInputBase-input': {
    color: 'black',
    backgroundColor: 'white',
  },
  '& .Mui-focused': {
    color: theme.palette.text.primary,
    backgroundColor: 'white',
    '& .MuiInputLabel-root': {
      color: 'rgba(0, 0, 0, 0.54)',
      backgroundColor: 'white',
    },
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
  backgroundColor: 'white',
  color: 'black',
  '&:hover': {
    backgroundColor: 'lightgray',
  },
}));

const EmployeeLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginClick = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    axios
      .post('/api/app/users/appLogin', {
        username: username,
        password: password,
      })
      .then((response) => {
        const decoded = jwt_decode(response.data.token);
        dispatch(
          setUserInformation({
            userID: decoded.user_id,
            contactID: decoded.contact_id,
            token: response.data.token,
            firstName: decoded.first_name,
            lastName: decoded.last_name,
            businessName: decoded.business_name,
          })
        );
        dispatch(setUserPermission(decoded.elements));
        navigate(loginDestination(), { replace: true });
      })
      .catch((error) => {
        console.log(error);
        setError('Incorrect username or password. Please try again.');
        setIsLoading(false);
      });
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  return (
    <Grid container sx={{ backgroundColor: theme.palette.primary.main, height: '100%' }}>
      <CssBaseline />
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: '600px', width: '100%', padding: theme.spacing(4) }}>
          {error && (
            <Alert severity='error' sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography component='h1' variant='h5' sx={{ color: 'white', textAlign: 'center' }}>
            Employee Login
          </Typography>
          <form onSubmit={handleLoginClick}>
            <StyledTextField
              variant='filled'
              margin='normal'
              required
              fullWidth
              id='emp-username'
              label='Username'
              name='username'
              autoComplete='username'
              value={username}
              onChange={handleUsernameChange}
              disabled={isLoading}
            />
            <StyledTextField
              variant='filled'
              margin='normal'
              required
              fullWidth
              name='password'
              label='Password'
              type='password'
              id='emp-password'
              autoComplete='current-password'
              value={password}
              onChange={handlePasswordChange}
              disabled={isLoading}
            />
            <StyledButton
              type='submit'
              fullWidth
              variant='contained'
              disabled={!username || !password || isLoading}
            >
              {isLoading ? <CircularProgress size={24} color='inherit' /> : 'Sign In'}
            </StyledButton>
            <Box sx={{ mt: 2 }}>
              <Typography variant='subtitle2' align='center' sx={{ color: 'white' }}>
                Contact Help Desk if you have trouble logging in.
              </Typography>
            </Box>
          </form>
        </Box>
      </Grid>
    </Grid>
  );
};

export default EmployeeLogin;
